module.exports = __webpack_public_path__ + "static/media/my-pic.6f4051a2.JPG";